// JS mirror of `$fds-breakpoints` in src/design/_tokens.scss — change both together.
// Desktop is 1025 until the Navigation slice moves the shell switch to Figma's 1200.
export const BREAKPOINT_TABLET = 768
export const BREAKPOINT_DESKTOP = 1025

export function isDesktopWidth(width: number): boolean {
    return width >= BREAKPOINT_DESKTOP
}
